<!--
		描述： 托管代收代付.vue
		创建时间： 2022-05-23 09:27:17
		作者： Wang Shuai
		邮箱： 591372242@qq.com
-->
<template>
	<div class="h100">
	  <filter-layout
		@search="doSearch"
		@reset="doReset"
		hasMore
		v-if="!routeQuery"
	  >
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="订单号：" prop="bizOrderNo">
			  <el-input
				v-model="searchForm.bizOrderNo"
				placeholder="请输入订单号"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="托管人名称：" prop="payer">
			  <el-input
				v-model="searchForm.payer"
				placeholder="请输入托管人名称"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="托管人(会员ID)：" prop="bizUserid" label-width="130px">
			  <el-input
				v-model="searchForm.bizUserid"
				placeholder="请输入托管人(会员ID)"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="业务来源：" prop="sysNo">
			  <el-select
				v-model="searchForm.sysNo"
				placeholder="请选择业务来源"
				size="small"
				clearable
			  >
				<!-- <el-option
				v-for="item in goodsType"
				:key="'goods' + item.value"
				:label="item.sname"
				:value="item.value"
			  ></el-option> -->
				<el-option label="聚易厅" value="1016001"></el-option>
				<el-option label="能工社运营" value="1016002"></el-option>
			  </el-select>
			</el-form-item>
		  </el-form>
		</template>
		<template #more>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="托管状态：" prop="payStatus">
			  <el-select
				v-model="searchForm.payStatus"
				placeholder="请选择托管状态"
				size="small"
			  >
				<el-option value="0" label="待托管"></el-option>
				<el-option value="1" label="托管中"></el-option>
				<el-option value="2" label="托管失败"></el-option>
				<el-option value="3" label="部分已代付"></el-option>
				<el-option value="4" label="全部已代付"></el-option>
				<el-option value="5" label="全部退款"></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="订单时间：" prop="startDate">
			  <div style="display: flex">
				<el-date-picker
				  v-model="searchForm.startDate"
				  type="date"
				  size="small"
				  placeholder="请选择"
				  value-format="yyyy-MM-dd"
				  :clearable="false"
				  :picker-options="startDatePicker"
				>
				</el-date-picker>
				<span class="text-center pd5">~</span>
				<el-date-picker
				  v-model="searchForm.endDate"
				  type="date"
				  size="small"
				  placeholder="请选择"
				  value-format="yyyy-MM-dd"
				  :clearable="false"
				  :picker-options="endDatePicker"
				>
				</el-date-picker>
			  </div>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">
			<div class="title">
			  合计代收：<span class="blue">{{ tablePage.total }}</span> 笔
			</div>
			<div class="btn-groups">
			  <!-- <el-button
				type="primary"
				class="btn-blue ml10"
				size="small"
				@click="searchToggle = !searchToggle"
			  >
				筛选
				<i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
				<i v-else class="el-icon-caret-top ml5"></i>
			  </el-button> -->
			  <el-button
				type="primary"
				class="btn-blue ml10"
				icon="el-icon-refresh"
				@click="doReset"
				size="small"
			  ></el-button>
			</div>
		  </div>
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content" v-show="tableShow" ref="table">
			  <vxe-table
				ref="xTable"
				:data="tableData"
				highlight-current-row
				highlight-hover-row
				border
				size="small"
				height="100%"
				resizable
				auto-resize
				show-overflow="tooltip"
				show-header-overflow="tooltip"
			  >
				<vxe-table-column
				  type="seq"
				  width="60px"
				  title="序号"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="bizOrderNo"
				  title="托管代收订单号"
				  header-align="center"
				  width="190px"
				></vxe-table-column>
				<vxe-table-column
				  field="amount"
				  title="托管金额"
				  header-align="center"
				  align="right"
				  width="100px"
				>
				  <template #default="{ row }">
					{{ row.amount.toFixed(2) }}
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="fee"
				  title="手续费"
				  width="75px"
				  header-align="center"
				  align="right"
				>
				  <template #default="{ row }">
					{{ row.fee.toFixed(2) }}
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="payerType"
				  title="托管人类型"
				  width="100px"
				  header-align="center"
				  align="center"
				>
				  <template #default="{ row }">
					{{ row.payerType === 0 ? "个人" : "企业" }}
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="payer"
				  title="托管人名称"
				  min-width="120px"
				  header-align="center"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="bizUserid"
				  title="托管人(会员Id)"
				  width="160px"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="payMethodName"
				  title="支付方式"
				  width="100px"
				  align="center"
				>
				</vxe-table-column>
				<vxe-table-column
				  field="sysName"
				  title="业务来源"
				  width="130px"
				  align="center"
				>
				</vxe-table-column>
				<vxe-table-column
				  field="createDate"
				  title="订单时间"
				  sortable
				  width="150px"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="payStatus"
				  title="资金托管状态"
				  width="120px"
				  align="center"
				>
				  <template #default="{ row }">
					<span
					  class="status"
					  :class="dealStatus(row.payStatus).class"
					  >{{ dealStatus(row.payStatus).text }}</span
					>
				  </template>
				</vxe-table-column>
				<vxe-table-column title="操作" width="220px" align="center">
				  <template v-slot="{ row }">
					<el-button
					  round
					  plain
					  class="table-btn"
					  type="primary"
					  size="small"
					  @click="showDetail(row)"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 详情
					</el-button>
					<template v-if="dealStatus(row.payStatus).showTools">
					  <el-button
						round
						plain
						class="table-btn"
						type="warning"
						size="small"
						@click="handleClick(row, 'payment')"
					  >
						代付
					  </el-button>
					  <el-button
						round
						plain
						type="danger"
						class="table-btn"
						size="small"
						@click="handleClick(row, 'refund')"
					  >
						<svg-icon icon-class="form-refund"></svg-icon> 退款
					  </el-button>
					</template>
				  </template>
				</vxe-table-column>
			  </vxe-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="searchForm.current"
				:page-size="searchForm.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tablePage.total"
			  >
			  </el-pagination>
			</div>
		  </div>
		</template>
		<el-dialog
		  :title="viewObj.title"
		  :visible.sync="viewObj.show"
		  :width="viewObj.width"
		  append-to-body
		  center
		  :close-on-click-modal="false"
		  @close="closeDialog"
		>
		  <div class="base-info">
			<el-row class="mb10">
			  <el-col :span="12" class="text-overflow">
				<span>源托管代收订单号：</span>
				<span>{{ viewObj.rowData.bizOrderNo }}</span>
			  </el-col>
			  <el-col :span="12" class="text-overflow">
				<span>托管日期：</span>
				<span>{{ viewObj.rowData.createDate }}</span>
			  </el-col>
			</el-row>
			<el-row class="mb10">
			  <el-col :span="12" class="text-overflow">
				<span>托管人名称：</span>
				<span>{{ viewObj.rowData.createUser }}</span>
			  </el-col>
			  <el-col :span="12" class="text-overflow">
				<span>托管人(会员ID)：</span>
				<span>{{ viewObj.rowData.bizUserid }}</span>
			  </el-col>
			</el-row>
			<el-row class="mb10">
			  <el-col :span="12" class="text-overflow">
				<span>托管人证件类型：</span>
				<span>{{
				  viewObj.rowData.cardType === 0 ? "身份证" : "营业执照"
				}}</span>
			  </el-col>
			  <el-col :span="12" class="text-overflow">
				<span>托管人证件号：</span>
				<span>{{ viewObj.rowData.cardNo }}</span>
			  </el-col>
			</el-row>
			<el-row class="mb10">
			  <el-col :span="12" class="text-overflow">
				<span>托管金额：</span>
				<span>{{ viewObj.rowData.amount }} 元</span>
			  </el-col>
			  <el-col :span="12" class="text-overflow">
				<span>剩余金额：</span>
				<span>{{ viewObj.rowData.surplusAmount }} 元</span>
			  </el-col>
			</el-row>
		  </div>
		  <el-divider></el-divider>
		  <div class="payment-form" v-if="viewObj.mode == 'payment'">
			<el-form
			  :model="paymentForm"
			  label-width="140px"
			  :rules="paymentRules"
			  size="small"
			  ref="paymentForm"
			  :show-message="false"
			>
			  <el-row>
				<el-col :span="22">
				  <el-form-item label="收款人：" prop="payee">
					<el-select
					  v-model="paymentForm.payee"
					  placeholder="请选择"
					  @change="onChangePayee"
					>
					  <el-option
						v-for="(item, index) in payees"
						:key="'payees' + index"
						:label="item.payee"
						:value="item.payeeId"
					  ></el-option>
					</el-select>
				  </el-form-item>
				  <p class="tips" v-if="!paymentForm.payee">
					提示：必须是源托管代收订单内收款人
				  </p>
				  <p class="tips" v-else>
					源托管代收订单代付金额<span class="color-blue"
					  >（{{ paymentForm.payer }}）</span
					>代付金额：<span class="color-blue">{{
					  viewObj.rowData.amount
					}}</span
					>元，已代付金额：<span class="color-blue">{{
					  parseInt(
						viewObj.rowData.amount - viewObj.rowData.surplusAmount
					  )
					}}</span>
					元，未代付金额：<span class="color-blue">{{
					  paymentForm.unpayAmount
					}}</span>
					元
				  </p>
				</el-col>
			  </el-row>
			  <el-row>
				<el-col :span="22" class="price-input">
				  <el-form-item label="代付金额：" prop="payMoney">
					<el-input-number
					  v-model="paymentForm.payMoney"
					  placeholder="请输入代付金额"
					  :min="0.01"
					  :precision="2"
					  :controls="false"
					  controls-position="right"
					  :disabled="!paymentForm.payee"
					  @keyup.enter.native="submitPrepay"
					>
					  <template slot="append">元</template>
					</el-input-number>
					<span class="price-append">元</span>
					<!-- <el-input
									  placeholder="请输入代付金额"
									  v-model="paymentForm.payMoney"
									  v-input-filter:intZ
									  :disabled="!paymentForm.payee"
								  >
									  <template slot="append">元</template>
								  </el-input> -->
				  </el-form-item>
				  <p class="tips">
					提示：代付金额必须小于等于剩余金额
					{{ viewObj.rowData.surplusAmount }} 元 (最小输入金额为 0.01)
				  </p>
				</el-col>
			  </el-row>
			  <el-row>
				<el-col :span="22">
				  <el-form-item label="收款人(会员ID)：" prop="bizUserid">
					<el-input
					  placeholder="请输入内容"
					  v-model="paymentForm.bizUserid"
					  disabled
					>
					</el-input>
				  </el-form-item>
				</el-col>
			  </el-row>
			  <el-row>
				<el-col :span="22">
				  <el-form-item label="收款人证件类型：" prop="cardTypeName">
					<el-input
					  placeholder="请输入内容"
					  v-model="paymentForm.cardTypeName"
					  disabled
					>
					</el-input>
				  </el-form-item>
				</el-col>
			  </el-row>
			  <el-row>
				<el-col :span="22">
				  <el-form-item label="收款人证件号：" prop="cardNo">
					<el-input
					  placeholder="请输入内容"
					  v-model="paymentForm.cardNo"
					  disabled
					>
					</el-input>
				  </el-form-item>
				</el-col>
			  </el-row>
			</el-form>
		  </div>
		  <div class="refund-form" v-else>
			<el-form
			  :model="refundForm"
			  label-width="140px"
			  :rules="refundRules"
			  size="small"
			  ref="refundForm"
			  :show-message="false"
			>
			  <el-row>
				<el-col :span="18">
				  <el-form-item label="退款金额：" prop="refundMoney">
					<el-input
					  placeholder="请输入退款金额"
					  v-model="refundForm.refundMoney"
					  disabled
					>
					  <template slot="append">元</template>
					</el-input>
				  </el-form-item>
				  <p class="tips">
					提示：剩余代付金额：
					<span class="color-blue">{{
					  viewObj.rowData.surplusAmount
					}}</span>
					元
				  </p>
				</el-col>
			  </el-row>
			  <el-row class="mt20">
				<el-col :span="24">
				  <p class="color-blue pdl10">
					温馨提示：提交退款成功后，资金会原路退回托管缴费账户
				  </p>
				</el-col>
			  </el-row>
			</el-form>
		  </div>
		  <span slot="footer" class="dialog-footer">
			<el-button
			  size="medium"
			  type="primary"
			  @click="doSubmit"
			  :loading="viewObj.btnLoading"
			  >提交</el-button
			>
			<el-button size="medium" @click="closeDialog">取 消</el-button>
		  </span>
		</el-dialog>
	  </filter-layout>
	  <div v-else>
		<!-- 托管代收代付详情 -->
		<AgentDetail />
	  </div>
	</div>
  </template>
<script>
import { payGetDicts } from "api/modules/dict";
import {
	escrowApply,
	escrowApplyInfo,
	getCollectDetail,
	getCollectPages,
	refundApply,
} from "api/modules/paymentSettlement";
import { mapState } from "vuex";

import AgentDetail from "./components/AgentDetail";

export default {
	components: {
		AgentDetail,
	},
	props: {},
	data() {
		return {
			searchForm: {
				bizOrderNo: "", //订单号
				payer: "", //托管人名称
				bizUserid: "", //托管人(会员ID)
				sysNo: "", //业务来源
				payStatus: "", //托管状态
				startDate: "", //订单开始时间
				endDate: "", //订单结束时间
				current: 1,
				size: 10
			},
			tableData: [],
			tablePage: {
				total: 0,
			},
			loading: false,
			searchToggle: true,
			tableShow: true,
			goodsType: [],
			viewObj: {
				show: false,
				title: "托管代付",
				width: "1000px",
				rowData: {},
				mode: "",
				btnLoading: false
			},
			startDatePicker: this.beginDate(),
			endDatePicker: this.processDate(),
			// 代付弹窗表单
			paymentForm: { //代付表单信息
				payMoney: "",//代付金额
				Payee: "", //收款人
				payId: "",//收款人（会员ID）
				payType: "",//收款人证件类型
				creaditCard: "",//收款人证件号
				unpayAmount: ''
			},
			paymentRules: {
				payMoney: [
					{ required: true, message: "请输入代付金额", trigger: "blur" },
				],
				payee: [{ required: true, message: "请选择收款人", trigger: "change" }],
				bizUserId: [
					{
						required: true,
						message: "请输入收款人（会员ID）",
						trigger: "blur",
					},
				],
				cardTypeName: [
					{ required: true, message: "请输入收款人证件类型", trigger: ["blur", 'change'] },
				],
				cardNo: [
					{ required: true, message: "请输入收款人证件号", trigger: ["blur", 'change'] },
				],
			},
			payees: [],	// 收款人列表
			// 退款表单
			refundForm:{
				refundMoney:''//退款金额
			},
			refundRules:{
				refundMoney:[{required: true, message: "请输入退款金额", trigger: "blur"}]
			}
		};
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem("agentBusiness")) {
				this.searchForm = JSON.parse(this.$getSessionItem("agentBusiness"));
				this.$removeSessionItem("payMoney");
			}
		}

		this.getTableData();
	},
	methods: {
		/****** 列表数据 ********/
		// 获取所有的代收
		getTableData() {
			let params = Object.assign({}, this.searchForm);
			getCollectPages(params)
				.then((d) => {
					this.tableData = d.data.records;
					this.tablePage.total = parseInt(d.data.total);
				})
				.catch(err => {})
		},
		// 点击搜索
		doSearch() {
			// 重置分页
			this.searchForm.current = 1;
			this.searchForm.size = 10;

			this.getTableData();
		},
		// 点击重置
		doReset() {
			this.searchForm = {
				bizOrderNo: "", //订单号
				payer: "", //托管人名称
        bizUserid: "", //托管人(会员ID)
				sysNo: "", //业务来源
				payStatus: "", //托管状态
				startDate: "", //订单开始时间
				endDate: "", //订单结束时间
				current: 1,
				size: 10
			}

			// 查询
			this.getTableData();
		},
		// 表格 每页条数切换
		handleSizeChange(size) {
			this.searchForm.size = size;
			this.getTableData();
		},
		// 表格 页码切换
		handleCurrentChange(cur) {
			this.searchForm.current = cur;
			this.getTableData();
		},
		// 处理资金托管状态
		dealStatus(status) {
			let obj = {
				0: {
					text: '待托管',
					class: 'warning-status',
					showTools: false
				},
				1: {
					text: '托管中',
					class: 'success-status',
					showTools: true
				},
				2: {
					text: '托管失败',
					class: 'error-status',
					showTools: false
				},
				3: {
					text: '部分已代付',
					class: 'warning-status',
					showTools: true
				},
				4: {
					text: '全部已代付',
					class: 'success-status',
					showTools: false
				},
				5: {
					text: '全部退款',
					class: 'success-status',
					showTools: false
				}
			}
			let key = status ? parseInt(status) : 0
			return obj[key]
		},

		/****** 查看跳转  &  代付、退款弹窗 ********/
		// 查看详情
		showDetail(row) {
			let params = Object.assign({}, this.searchForm);

			// 存值
			this.$setSessionItem("agentBusiness", JSON.stringify(this.searchForm));
			this.$setSessionItem('agentDetailId', row.id)

			this.$router.push({
				path: "/agent-business",
				query: {
					type: "agent-detail",
				},
			});
		},
		// 代付/退款
		handleClick(data, type) {
			this.viewObj.rowData = this.$utils.clone(data, true);
			switch (type) {
				case "payment":
					this.viewObj.show = true;
					this.viewObj.title = "托管代付";
					this.viewObj.mode = "payment";

					// 接口
					this.getPayers(data.id)
					break;
				default:
					this.viewObj.show = true;
					this.viewObj.title = "退款";
					this.viewObj.mode = "refund";
					this.refundForm.refundMoney = data.surplusAmount
			}
		},
		// 代付申请 - 获取收款人
		getPayers(id) {
			escrowApplyInfo({ id })
				.then(res => {
					this.payees = res.data.payees
				})
				.catch(err => {})
		},
		// 切换收款人
		onChangePayee(val) {
			let item = this.payees.find(x => x.payeeId === val)
			if (item) {
				this.paymentForm.bizUserid = item.bizUserid
				let _cardTypeName = item.cardType === 0 ? '身份证' : '营业执照'
				this.$set(this.paymentForm, 'cardTypeName', _cardTypeName)
				this.$set(this.paymentForm, 'cardNo', item.cardNo)
				this.$set(this.paymentForm, 'payer', item.payee)
				this.$set(this.paymentForm, 'unpayAmount', item.unpayAmount)
			}
		},
		// 提交 代付、退款
		doSubmit() {
			let params = {
				createUser: this.userInfo.sname,
				createUserid: this.userInfo.id,
				oldOrderNo: this.viewObj.rowData.bizOrderNo,
				sysNo: '1016002',	// 系统识别号
				source: 2   // 1：手机端；2：PC端
			}
			this.viewObj.btnLoading = true
			switch (this.viewObj.mode) {
				case "payment":
					this.$refs.paymentForm.validate(valid => {
						if (!valid) {
							this.$message.warning('请完善必填项！')

							this.cancelLoading()
							return
						}

						params.amount = this.paymentForm.payMoney
						params.payeeId = this.paymentForm.payee
						params.bizUserId = this.paymentForm.bizUserid
						// params.orderId = this.paymentForm.bizUserid
						if (parseFloat(params.amount) > this.viewObj.rowData.surplusAmount) {
							this.$message.warning('代付金额必须小于等于剩余金额！')
							this.cancelLoading()
							return
						}

						if (parseFloat(params.amount) > this.paymentForm.unpayAmount) {
							this.$message.warning('代付金额必须小于等于剩余代付金额！')
							this.cancelLoading()
							return
						}

						escrowApply(params)
							.then(res => {
								this.$message.success('代付成功！即将返回...')
								this.cancelLoading()

								setTimeout(() => {
									this.closeDialog()
									this.doSearch()
								}, 1000)
							})
							.catch(err => {
								this.cancelLoading()
							})
					})
					break;
				case 'refund':
					this.$refs.refundForm.validate(valid => {
						if (!valid) {
							this.$message.warning('请完善必填项！')
							this.cancelLoading()
							return
						}

						params.amount = this.refundForm.refundMoney
						if (parseFloat(params.amount) > this.viewObj.rowData.surplusAmount) {
							this.$message.warning('退款金额必须小于等于剩余代付金额！')
							this.cancelLoading()
							return
						}

						refundApply(params)
							.then(res => {
								this.$message.success('退款成功！即将返回...')
								this.cancelLoading()

								setTimeout(() => {
									this.closeDialog()
									this.doSearch()
								}, 1000)
							})
							.catch(err => {
								this.cancelLoading()
							})
					})
					break
			}
		},
		// 取消按钮loading
		cancelLoading() {
			setTimeout(() => {
				this.viewObj.btnLoading = false
			}, 1500)
		},
		// 关闭查看申请服务的弹框
		closeDialog() {
			this.viewObj.title = "";
			this.viewObj.show = false;
			this.viewObj.mode = "";
			this.viewObj.rowData = {};

			this.paymentForm.payMoney = ''
			this.paymentForm.payee = ''
			this.paymentForm.bizUserid = ''
			this.paymentForm.cardTypeName = ''
			this.paymentForm.cardNo = ''
			this.paymentForm.unpayAmount = ''

			this.refundForm.refundMoney = ''
			this.payees = []
		},

		// 返回
		goBack() {
			this.$router.push({ path: "/pay-money" });
		},

		/****** 时间控件处理 ********/
		// 开始时间的 pickOption
		beginDate() {
			let that = this;
			return {
				disabledDate(time) {
					let endTime = "";
					endTime = that.searchForm.endDate;
					if (endTime) {
						return bmElementTimeOptins.limitDateBefore(time, endTime, true);
					} else {
						return time.getTime() > Date.now();
					}
				},
			};
		},
		// 结束时间的 pickOption
		processDate() {
			let that = this;
			return {
				disabledDate(time) {
					let startTime = "";
					startTime = that.searchForm.startDate;
					if (startTime) {
						let nowTime = Date.now();
						return bmElementTimeOptins.limitDateInRange(
							time,
							startTime,
							nowTime,
							true
						);
					} else {
						return time.getTime() > Date.now();
					}
				},
			};
		},
	},
	computed: {
		routeQuery() {
			return this.$route.query.type;
		},
		...mapState("app", {
			isBack: (state) => state.isBack,
		}),
		...mapState("menu", {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState("user", {
			userInfo: (state) => state.userInfo,
		}),
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false;
			setTimeout(() => {
				this.tableShow = true;
			}, 50);
		},
	},
};
</script>
<style lang="less" scoped>
.pay-money {
	.el-form {
		border-bottom: 1px solid #2671cc;
	}
	.btn-style {
		width: 80px;
		height: 32px;
	}
	.btn-blue {
		background-color: #2671cc !important;
		color: #fff;
	}
	.operation-header {
		display: block;
		line-height: 40px;

		.number-toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.number {
				padding-left: 10px;
				border-left: 4px solid #2671cc;
				height: 30px;
				line-height: 30px;

				span {
					color: #2671cc;
					font-size: 18px;
				}
			}
		}
	}
	.operation-container {
		height: calc(~"100% - 52px") !important;
	}
	/deep/ .vxe-cell--title {
		color: #202020;
		font-size: 14px;
		font-weight: normal;
	}
	.money-detail {
		padding: 30px 50px 0 50px;
		height: calc(~"100% - 50px");
		span {
			font-size: 14px;
		}
	}
	.mb10 {
		margin-bottom: 10px !important;
	}
	.green {
		color: green;
	}
	.red {
		color: red;
	}
	.greens,
	.reds,
	.yellows {
		// padding-left: 20px;
	}
	.greens::before {
		content: "";
		display: inline-block;
		width: 12px;
		height: 12px;
		line-height: 12px;
		margin-right: 10px;
		vertical-align: middle;
		border-radius: 50%;
		background-color: #72aa2c;
		box-shadow: 0px 0px 4px 0px #72aa2c;
	}
	.reds::before {
		content: "";
		display: inline-block;
		width: 12px;
		height: 12px;
		line-height: 12px;
		margin-right: 10px;
		vertical-align: middle;
		border-radius: 50%;
		background-color: red;
		box-shadow: 0px 0px 4px 0px red;
	}
	.yellows::before {
		content: "";
		display: inline-block;
		width: 12px;
		height: 12px;
		line-height: 12px;
		margin-right: 10px;
		vertical-align: middle;
		border-radius: 50%;
		background-color: orange;
		box-shadow: 0px 0px 4px 0px orange;
	}
}
.bgc {
	background-color: #fff;
}

.payment-form, .refund-form {
	.tips {
		position: absolute;
    	top: 33px;
    	left: 150px;
    	font-size: 12px;
    	color: #909399;
	}
}

.price-input {
	position: relative;

	/deep/ .el-input-number {
		width: 100%;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
		padding-right: 35px;
	}

	.price-append {
		position: absolute;
		right: 12px;
	}
}
.content-header{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	.title {
	  padding-left: 10px;
	  border-left: 4px solid #2671cc;
	  font-size: 14px;
	  color: #202020;
	}
	.blue{
	  font-size: 18px;
	  color: #2671cc;
	}
  }
  .pd5{
	padding: 0 5px;
  }
</style>
